// Find values that don't intersect between arrays and are unique
export const findIntersectionLeftovers = <T = string>(
  arr1: T[],
  arr2: T[]
): T[] => {
  const set1 = new Set(arr1);
  const set2 = new Set(arr2);

  const uniqueInArr1 = arr1.filter((item) => !set2.has(item));
  const uniqueInArr2 = arr2.filter((item) => !set1.has(item));

  return Array.from(new Set([...uniqueInArr1, ...uniqueInArr2]));
};
